import AmplitudeHelper from "utils/analytics";

export const logOfflineEvent = () => {
  AmplitudeHelper.logEvent("internal_server_error_toast", {
    failure_message: "internet_connection_lost",
  });
};
